export const onChangeSelectCB = (attr, setAttributes) => val =>
	setAttributes({ [attr]: val.value });

export const getCurrentSelected = (options, value) =>
	options.find(op => op.value === value);

export const onChangeInputCB = (attr, setAttributes) => e =>
	setAttributes({ [attr]: e.target.value });

export const convertElmChartsToNative = charts => {
	const c = { ...charts };
	delete c.default;
	return Object.keys(c).map(key => ({ label: c[key], value: key }));
};

export const convertServerFilterItemsToNativeSelect = items =>
	items.map(({ text, value }) => ({ label: text, value }));

export function toggleAttributeBasedOnString(attr, attributes, setAttributes) {
	const newVal = attributes[attr] === '1' ? '0' : '1';
	setAttributes({ [attr]: newVal });
}

export function getToggleAttributeBoolValueBasedOnString(attr, attributes) {
	return attributes[attr] === '1';
}

export function handleTopLevelInput(e, setAttributes) {
	const { target } = e;
	const { value, name } = target;
	setAttributes({ [name]: value });
}

export function toggleAttribute(attr, attributes, setAttributes) {
	setAttributes({ [attr]: !attributes[attr] });
}
